import React from 'react';
import PT from 'prop-types';
import cn from 'classnames';

const RadioButtonGroup = ({ names, callback }) => {
  const handleClick = (e) => {
    callback(e.target.textContent);
  };

  return (
    <>
      <div className="radio-button-group">
        {names.map((name, id) => (
          <button
            key={id}
            className={cn('radio-button-group__item', { 'radio-button-group__item--active': name.active })}
            onClick={handleClick}
            data-testid={name.label}
          >
            {name.label}
          </button>
        ))}
      </div>
    </>
  );
};

RadioButtonGroup.propTypes = {
  names: PT.arrayOf(
    PT.shape({
      labe: PT.string,
      active: PT.bool,
    })
  ),
  callback: PT.func,
};

export default RadioButtonGroup;
